import TourPage from "@/components/TourPage";

export default function KenyaMagical9Day() {
  return (
    <TourPage
      tourId="kenya/magical-9-day"
      title="9 Days Magical Kenya Safari"
      duration="9 Days / 8 Nights"
      price="Contact for price"
      image="/kenyssafarizebra.jpg"
      description="Experience the ultimate Kenya safari adventure across multiple national parks and reserves. This comprehensive 9-day journey takes you through Samburu, Ol Pejeta, Lake Nakuru, and the Masai Mara."
      itinerary={[
        {
          day: 1,
          title: "Nairobi to Samburu",
          description: "Begin your journey to northern Kenya.",
          activities: [
            "Morning pickup from Nairobi",
            "Drive to Samburu National Reserve",
            "Evening game drive",
            "Dinner and overnight at lodge"
          ],
          accommodation: "Samburu Lodge",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Samburu National Reserve",
          description: "Explore unique northern species.",
          activities: [
            "Morning game drive",
            "Afternoon game drive",
            "View special northern species",
            "Optional visit to Samburu village"
          ],
          accommodation: "Samburu Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Samburu to Ol Pejeta",
          description: "Travel to the famous Ol Pejeta Conservancy.",
          activities: [
            "Drive to Ol Pejeta Conservancy",
            "Visit the chimpanzee sanctuary",
            "Evening game drive",
            "Night game drive option"
          ],
          accommodation: "Ol Pejeta Camp",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Ol Pejeta Conservancy",
          description: "Conservation and wildlife experiences.",
          activities: [
            "Visit the rhino sanctuary",
            "Game drives in the conservancy",
            "Visit to the endangered species enclosure",
            "Evening sundowner"
          ],
          accommodation: "Ol Pejeta Camp",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Ol Pejeta to Lake Nakuru",
          description: "Journey to the flamingo-rich lake.",
          activities: [
            "Drive to Lake Nakuru National Park",
            "Afternoon game drive",
            "Bird watching",
            "View rhinos and lions"
          ],
          accommodation: "Lake Nakuru Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Lake Nakuru to Masai Mara",
          description: "Travel to the iconic Masai Mara.",
          activities: [
            "Morning game drive at Lake Nakuru",
            "Drive to Masai Mara",
            "Evening game drive",
            "Sunset viewing"
          ],
          accommodation: "Mara Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Masai Mara Reserve",
          description: "Full day in the Mara ecosystem.",
          activities: [
            "Full day of game drives",
            "Visit to Mara River",
            "Track the Big Five",
            "Optional balloon safari"
          ],
          accommodation: "Mara Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 8,
          title: "Masai Mara Experience",
          description: "More Mara adventures.",
          activities: [
            "Morning game drive",
            "Visit to Masai village",
            "Afternoon game drive",
            "Evening cultural activities"
          ],
          accommodation: "Mara Lodge",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 9,
          title: "Masai Mara to Nairobi",
          description: "Final safari day and return.",
          activities: [
            "Morning game drive",
            "Drive back to Nairobi",
            "Optional city tour",
            "Drop-off at hotel/airport"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All accommodation",
        "Professional safari guide",
        "All park entrance fees",
        "Transportation in 4x4 vehicle",
        "All game drives",
        "Bottled water",
        "All meals as specified"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Optional activities",
        "Drinks and beverages"
      ]}
    />
  );
}
